import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'trademarkList',
    component: r => require.ensure([], () => r(require('@/components/notice/trademarkList.vue')), 'trademarkList')
  },
  {
    path: '/trademarkDetail',
    name: 'trademarkDetail',
    component: r => require.ensure([], () => r(require('@/components/notice/trademarkDetail.vue')), 'trademarkDetail')
  },
  {
    path: '/trademarkDetailMore',
    name: 'trademarkDetailMore',
    component: r => require.ensure([], () => r(require('@/components/notice/trademarkDetailMore.vue')), 'trademarkDetailMore')
  },
]

const router = new VueRouter({
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js